import React from 'react';
import './navBar.scss';
import { BACK, ENTER, RIGHT, LEFT, UP } from '../../util/remoteButtons';

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   playlist: props.playlist || {},
    //   showDetails: props.showDetails || false,
    //   hasFocus: props.hasFocus || false,
    // };
    this.selectedBtn = "None";
    // this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  async componentDidMount() {
    if (this.props.subscription) {
      this.selectedBtn = "Account";
      this.refs.account.focus();
      document.getElementById("account").classList.add("active");
    } else {
      this.selectedBtn = "Pair";
      this.refs.pair.focus();
      document.getElementById("pair").classList.add("active");
    }
    // window.onkeyup = (e) => {
    //   switch (e.which) {
    //     case RIGHT:
    //       if ((this.selectedBtn === "Pair" || this.selectedBtn === "Account") && this.props.subscription) {
    //         this.refs.settings.focus();
    //         this.selectedBtn = "Settings";
    //         if (this.props.subscription) 
    //         document.getElementById("account").classList.remove("active");
    //         else
    //         document.getElementById("pair").classList.remove("active");
    //         document.getElementById("settings").classList.add("active");
    //       } else if (this.selectedBtn === "Settings") {
    //         this.refs.help.focus();
    //         this.selectedBtn = "Help";
    //         document.getElementById("settings").classList.remove("active");
    //         document.getElementById("help").classList.add("active");
    //       }
    //       else {
    //         this.refs.help.focus();
    //         this.selectedBtn = "Help";
    //         document.getElementById("pair").classList.remove("active");
    //         document.getElementById("help").classList.add("active");
    //       }
    //       break;
    //     case LEFT:
    //       if (this.selectedBtn === "Help" && this.props.subscription) {
    //         this.refs.settings.focus();
    //         this.selectedBtn = "Settings";
    //         document.getElementById("help").classList.remove("active");
    //         document.getElementById("settings").classList.add("active");
    //       } else if (this.selectedBtn === "Settings") {
    //         if (this.props.subscription) {
    //           this.refs.account.focus();
    //           this.selectedBtn = "Account";
    //           document.getElementById("settings").classList.remove("active");
    //           document.getElementById("account").classList.add("active");
    //         }
    //         else {
    //           this.refs.pair.focus();
    //           this.selectedBtn = "Pair";
    //           document.getElementById("settings").classList.remove("active");
    //         document.getElementById("pair").classList.add("active");
    //         }
    //       }
    //       else {
    //         this.refs.pair.focus();
    //         this.selectedBtn = "Pair";
    //         document.getElementById("help").classList.remove("active");
    //         document.getElementById("pair").classList.add("active");
    //       }
    //       break;
    //     case ENTER:
    //       if (this.selectedBtn === 'Account') {
    //         this.selectedBtn = 'None';
    //         this.props.onNavigation('Account');
    //       } else if (this.selectedBtn === 'Pair') {
    //         this.selectedBtn = 'None';
    //         this.props.onNavigation('Pair');
    //       } else if (this.selectedBtn === 'Settings') {
    //         this.selectedBtn = 'None';
    //         this.props.onNavigation('Settings');
    //       }
    //       break;
    //     case 27:
    //     case BACK:
    //       this.props.onNavigation("Hide");
    //       break;
    //   }
    // };
  }
  

  handleClick(navTo) {
    this.props.onNavigation(navTo);
  }

  render() {
    return (
      <div className="navBar" ref="topBar">
        {/* <div className="navBar_active" id="active"></div> */}
        <div className="navBar_pages">
          {this.props.subscription ?
            <div className="navBar_pages_item account" id="account" onClick={() => { this.handleClick('Account'); }} style={{ left: '0px' }}>
              <div className="navBar_pages_item_text">Account</div>
              <div className="navBar_pages_item_imgWrapper" onKeyDown={this.handleKeyDown} ref="account">
                <img src="/assets/img/account.png" className="navBar_pages_item_imgWrapper_img" />
              </div>
            </div>
            :
            <div className="navBar_pages_item account" id="pair" onClick={() => { this.handleClick("Pair") }} style={{ left: '0px' }}>
              <div className="navBar_pages_item_text">Pair Device</div>
              <div className="navBar_pages_item_imgWrapper" ref="pair">
                <img src="/assets/img/pair.png" className="navBar_pages_item_imgWrapper_img" />
              </div>
            </div>
          }
          <div className="navBar_pages_item settings" id="settings" onClick={() => { if (this.props.subscription) this.handleClick("Settings") }}>
            <div className="navBar_pages_item_text">Settings</div>
            <div className="navBar_pages_item_imgWrapper" onKeyDown={this.handleKeyDown} ref="settings">
              <img src="/assets/img/settings.png" className="navBar_pages_item_imgWrapper_img" style={{ left: '330px' }} />
            </div>
          </div>
          <div className="navBar_pages_item help" id="help">
            <div className="navBar_pages_item_text">Help</div>
            <div className="navBar_pages_item_imgWrapper" onKeyDown={this.handleKeyDown} ref="help">
              <img src="/assets/img/help.png" className="navBar_pages_item_imgWrapper_img" style={{ left: '600px' }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
